export const EMAIL_INVALID_ERROR = 'Your email must be valid and contain an @ in the address'

export const PHONE_NUMBER_ERROR = {
  INVALID: 'Phone number must begin with 04 and contain 10 digits',
  LENGTH: 'Phone number must contain 10 digits'
}

export const PASSWORD_LENGTH_ERROR_MESSAGE = 'Your password must have at least 8 characters'
